import { configureStore } from '@reduxjs/toolkit';
import {
  authReducer,
  clientsReducer,
  documentsReducer,
  invoiceReducer,
} from './slices';
import { profileReducer } from './slices/profileSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    clients: clientsReducer,
    invoices: invoiceReducer,
    profile: profileReducer,
    document: documentsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
